import React from 'react';
import { Link, useParams, useRouteLoaderData } from 'react-router-dom';
import { format } from 'date-fns';
import useSWR from 'swr';

import { Button } from '@nearst/ui';
import { useShop } from '@services/ShopProvider';
import { getCustomer } from '@services/billing';
import styles from './UpgradeReviewPlan.module.scss';

const UpgradeReviewPlan = () => {
	const { pricing } = useRouteLoaderData('upgrade');

	const { productId, period } = useParams();
	const plan = pricing[period];

	// Determine if the customer has a payment method setup
	const { data: shops } = useShop();
	const { data: customer } = useSWR([shops[0].id, 'customer'], getCustomer);
	const hasPaymentMethod = customer?.paymentMethod;

	const basePath = `/upgrade/${productId}/${period}`;
	const nextUrl = hasPaymentMethod ? `${basePath}/confirm` : `${basePath}/payment`;

	return (
		<div className={styles.container}>
			<h2>NearSt {pricing.title}</h2>
			{pricing.description && <p>{pricing.description}</p>}

			<div className={styles.group}>
				<label>
					{plan.price} per location, billed {period}
				</label>
				<p>Subscription starts {format(new Date(), 'MMMM do, yyyy')}</p>
			</div>

			<Button as={Link} to={nextUrl} primary className={styles.button}>
				Continue
			</Button>
		</div>
	);
};

export default UpgradeReviewPlan;
